import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Stack, Tooltip
} from "@mui/material";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";

const YesNoChip = ({ value }) => {
  const normalized = value?.toString().toLowerCase();
  const isYes = normalized === "yes" || normalized === "true";

  return (
    <Chip
      label={isYes ? "Yes" : "No"}
      size="small"
      sx={{
        backgroundColor: isYes ? "#c8f7c5" : "#f7c5c5",
        color: "#000",
        fontWeight: 600
      }}
    />
  );
};

const InfoRow = ({ label, value, titleDef = "" }) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Tooltip title={titleDef} arrow>
        <Typography sx={{ fontWeight: 500, color: "text.secondary"}}>
        {label}:
        </Typography>
    </Tooltip>
    {typeof value === "boolean" ? (
      <YesNoChip value={value} />
    ) : (
      <Typography>{value || "—"}</Typography>
    )}
  </Stack>
);

const SectionTitle = ({ children }) => (
  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
    <SmsFailedIcon />
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      {children}
    </Typography>
  </Stack>
);

const UberGuestRider = ({ data }) => {
  return (
    <Card>
      <CardContent>
        <SectionTitle>Status</SectionTitle>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <InfoRow label="Is Mobile" value={data?.is_mobile} titleDef="true if the phone number provided is a mobile number."/>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InfoRow label="Unsubscribed from SMS" value={data?.is_unsubscribed_sms} titleDef="true if the phone number has unsubscribed from Uber SMS messaging."/>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InfoRow label="Opt-In Number" value={data?.sms_opt_in_number} titleDef="Phone number the user can text to opt back into Uber SMS messaging" />
          </Grid>

          <Grid item xs={12}>
            <InfoRow label="Message" value={data?.message} titleDef="Instructions on how to opt-in to receive Uber SMS messages."/>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default UberGuestRider;
